import React from 'react'

const ModalGuardarCorrectamenteListaChequeo = ({setmodalOnInformacionGuardaCorrectamente, setmodalOnConfirmarListaChequeo, setmodalOnListaChequeo, setmodalOnCambioEstadoIngresoSala, passDataActualizaTablaPacientes, dataListaChequeo}) => {
    const handleCancelarClick=()=>{
        setmodalOnInformacionGuardaCorrectamente(false)
        setmodalOnConfirmarListaChequeo(false)
        setmodalOnListaChequeo(false)
        setmodalOnCambioEstadoIngresoSala(false)
        passDataActualizaTablaPacientes(dataListaChequeo)
    }
  return (
    <div
      className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto pt-20 bg-slate-900 bg-opacity-25"
      id="exampleModalScrollable"
      tabIndex="-1"
      aria-labelledby="exampleModalScrollableLabel"
      aria-hidden="true"
    >
      <div className="sm:h-[calc(100%-1rem)] max-w-xl  mx-auto relative w-auto pointer-events-none ">
        <div className="max-h-full overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
          <div className="flex flex-shrink-0 items-center justify-between p-2 border-b border-gray-200 rounded-t-md">
            <h5
              className="text-xl font-medium leading-normal text-gray-800"
              id="exampleModalScrollableLabel"
            >
              
            </h5>
            <button
              type="button"
              onClick={handleCancelarClick}
              className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              X
            </button>
          </div>
         
          <div className="mt-3 text-center">
		<div
			className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100"
		>
			<svg
				className="h-6 w-6 text-green-600"
				fill="none"
				stroke="currentColor"
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth="2"
					d="M5 13l4 4L19 7"
				></path>
			</svg>
		</div>
		<h3 className="text-lg leading-6 font-medium text-gray-900">La información fue registrada con éxito!</h3>
		<div className="mt-2 px-7 py-3">
			<p className="text-sm text-gray-500">
				
			</p>
		</div>
		<div className="items-center px-4 py-3">
      
			<button
                type="button"
             onClick={handleCancelarClick}
				id="ok-btn"
				className="px-4 py-2 bg-green-500 text-white text-base font-medium rounded-md w-full shadow-sm hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-300"
			>
				OK
			</button>
      
		</div>
	</div>
          
        </div>
      </div>
      
    </div>
  )
}

export default ModalGuardarCorrectamenteListaChequeo